// extracted by mini-css-extract-plugin
export var blue = "_26-f";
export var brand = "_26-b";
export var darkGrey = "_26-e";
export var disabled = "_26-4";
export var disabledSubtle = "_26-5";
export var error = "_26-6";
export var green = "_26-g";
export var grey = "_26-d";
export var icon = "_26-0";
export var inherit = "_26-a";
export var lightGrey = "_26-c";
export var orange = "_26-i";
export var pink = "_26-k";
export var primary = "_26-1";
export var purple = "_26-l";
export var red = "_26-j";
export var secondary = "_26-2";
export var success = "_26-9";
export var tertiary = "_26-3";
export var warning = "_26-7";
export var warningSecondary = "_26-8";
export var white = "_26-m";
export var yellow = "_26-h";